<script lang="ts">
    import type {Option} from "./option";

    export let value: number;
    export let options: Option[];

    let expanded = false;

    function cast(opt: any): Option {
	    return opt;
    }

    function toggleDropdown(e: Event) {
	    e.preventDefault();
	    e.stopPropagation();
	    expanded = !expanded;
    }
</script>

<svelte:window on:click={() => expanded = false}/>

<span class="dropdown-el w-100" class:expanded={expanded} on:click={toggleDropdown}>
    {#each options as option}
        {@const selectID = 'option-' + Math.random() * 100000}
        <!-- TODO: what is sortType for? -->
        <input id={selectID} type="radio" value={cast(option).value} name="sortType"
               checked={value == cast(option).value} on:click={() => value = option.value}>
        <label for={selectID} on:click={() => value = option.value}>{cast(option).label}</label>
    {/each}
</span>
